import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Outlet,
  Route,
  ScrollRestoration
} from 'react-router-dom'

import ProtectedLayout from './components/security/ProtectedLayout'
import { ROUTE_PATHS } from './config/settings/routes.config'
import { AuthProviderContainer } from './containers/AuthProvider'
import { Header } from './containers/Header'
import AppLayout from './layouts/AppLayout'
import { CfmpPage, NotFoundPage } from './pages'

/**
 * Main routing configuration component.
 * Creates and exports the browser router with all application routes.
 */
const routeComponents = [
  <Route element={<Navigate replace to={ROUTE_PATHS.CFMP} />} key="root" path={ROUTE_PATHS.ROOT} />,

  <Route element={<ProtectedLayout />} key="protected">
    <Route
      element={<CfmpPage />}
      handle={{ breadcrumb: 'Registrar compra' }}
      key="cfmp"
      path={ROUTE_PATHS.CFMP}
    />
  </Route>,

  <Route element={<NotFoundPage />} key="not-found" path={ROUTE_PATHS.NOT_FOUND} />
]

export const Routing = createBrowserRouter(
  createRoutesFromElements(
    <Route
      element={
        <AppLayout header={<Header />}>
          <AuthProviderContainer>
            <ScrollRestoration />
            <Outlet />
          </AuthProviderContainer>
        </AppLayout>
      }
    >
      {routeComponents}
    </Route>
  )
)
